<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            ref="modal-service-fee"
            @hidden="clearService"
            id="modal-service-fee"
            hide-footer
        >
            <template slot="modal-title">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                <div class="col-12">
                    <h3 class="mb-0">บริการเสริม</h3>
                </div>
                </div>
            </div>
            </template>
            <card shadow type="secondary" class="m--4">
            <template>
                <form @submit.prevent>
                <div class>
                    <div class="row">
                    <div class="col-lg-12">
                        <div class="group-result">
                        <div class="price">
                            <div class="col-lg-6">
                            <h6>บริการ</h6>
                            </div>
                            <div class="col-lg-6">
                            
                                <v-select 
                                :class="[ { 'is-invalid bd-danger': submitAddService && $v.fee.name.$error } , 'w-100' ]"
                                v-model="fee.name" 
                                :options="service"
                                ></v-select> 
                                <div
                                v-if="submitAddService && $v.fee.name.required == false"
                                class="invalid-feedback d-block">กรุณาเลือกบริการ
                                </div> 
                                
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-12" v-if="fee.name == 'อื่นๆ'">
                        <div class="group-result">
                        <div class="price">
                            <div class="col-lg-6">
                            <h6>รายละเอียด</h6>
                            </div>
                            <div class="col-lg-6">
                            <input
                                type="text"
                                class="form-control"
                                v-model="fee.serviceOther"
                                :class="{ 'is-invalid': submitAddService && $v.fee.serviceOther.$error }"
                            />
                            <div
                                v-if="submitAddService && $v.fee.serviceOther.required == false"
                                class="invalid-feedback d-block">กรุณากรอกรายละเอียด
                            </div> 
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="price">
                        <div class="col-lg-6">
                            <h6>จำนวนเงิน (บาท)</h6>
                        </div>
                        <div class="col-lg-6">
                            <base-input
                            formClasses="mb-0"
                            alternative
                            typeInput="number"
                            placeholder="0"
                            :input-classes="(submitAddService && $v.fee.rate.$error) ? 'is-invalid bd-danger' : '' + ' form-control-alternative'"
                            size="lg"
                            v-model="fee.rate"
                            />
                            <div
                            v-if="submitAddService && $v.fee.rate.required == false"
                            class="invalid-feedback d-block">กรุณากรอกจำนวนเงิน
                            </div> 
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="group-result">
                        <div class="price">
                            <div class="col-lg-6">
                            <h6>ค่าบริการ (บาท)</h6>
                            </div>
                            <div class="col-lg-6">
                            <base-input
                                formClasses="mb-0"
                                alternative
                                typeInput="number"
                                placeholder="0"
                                :input-classes="(submitAddService && $v.fee.rate.$error) ? 'is-invalid bd-danger' : '' + ' form-control-alternative'"
                                size="lg"
                                v-model="fee.fee"
                            />
                            <div
                                v-if="submitAddService && $v.fee.fee.required == false"
                                class="invalid-feedback d-block">กรุณากรอกค่าบริการ
                            </div> 
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="group-result">
                        <div class="price">
                            <div class="col-lg-6">
                            <h6>หมายเหตุ</h6>
                            </div>
                            <div class="col-lg-6">
                                <textarea 
                                class="form-control form-control-sm" 
                                rows="2"
                                v-model="fee.remark" >
                                </textarea>
                            </div>
                        </div>
                        </div>
                        <hr class="my-4" />
                    </div>
                    <div class="col-lg-12">
                        <div class="group-result">
                        <div class="price">
                            <h6>ยอดสุทธิ</h6>
                            <h1>
                            {{( Number(fee.rate) + Number(fee.fee) ) | numFormat('0,0.00')}}
                            <small>บาท</small>
                            </h1>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="mt-4 w-100 text-right">
                    <b-button variant="secondary" @click="clearService()">ยกเลิก</b-button>
                    <b-button type="submit" variant="success" @click="beforeAddService()">ยืนยัน</b-button>
                </div>
                </form>
            </template>
            </card>
        </b-modal>
    </div>
</template>

<script>
import {
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
    name:'ModalService',
    props:{
        fee: Object,
    },
    data(){
        return{
            submitAddService: false,
            service: [
                "ค่าไฟฟ้า",
                "ค่าน้ำ",
                "เติมเงินมือถือ",
                "ค่าตั๋วเครื่องบิน",
                "อื่นๆ"
            ],
        }
    },
    validations: {
        fee: {
            name: { required },
            rate: { required },
            fee: { required  },
            serviceOther: { required: requiredIf(function (service) {
                return service.name == 'อื่นๆ'
            })}
        }
    },
    methods:{
        clearService() {
            Object.keys(this.fee).forEach(key => {
                this.fee[key] = "";
            });
            this.submitAddService = false;
            this.$refs['modal-service-fee'].hide();
        },
        beforeAddService() {
            this.submitAddService = true;
            this.$v.fee.$touch();
            if (this.$v.fee.$invalid) {
                return false;   
            }
            if( this.fee.name == 'อื่นๆ' ){
                this.fee.name = this.fee.serviceOther
            }
            this.$emit('addService');
            this.clearService();
        },
    }
}
</script>